<template>
  <div>
    <vs-row vs-justify="center" class="mt60">
      <vs-col vs-xs="12"></vs-col>
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-sm="6" vs-lg="4" vs-xs="12">
        <vs-card class="cardx">
          <div slot="header">
            <h4>
              Login
              <img
                @click="imgClick"
                size="40px"
                style="float: right; margin-top: -8px; height: 25px"
                :src="require('@/assets/images/logo/logo-icon.png')"
              />
            </h4>
          </div>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Email Id" v-model="login.email" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Password" type="password" @keyup.enter="btnLoginClick" v-model="login.password" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="text-center" v-if="!isLocalhost">
              <div class="g-recaptcha" :data-sitekey="captchaKey"></div>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-button @click="btnLoginClick" :disabled="!login.email || !login.password" color="primary">Login</vs-button>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="flink">
              <router-link to="/forgot-password">Forgot Password?</router-link>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <div class="text-center">
      <small>Powered By - saaslabs.in</small>
    </div>
  </div>
</template>

<script>
import api from "../rest.js";
import { API } from "../common/constants";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      login: {
        email: "",
        password: "",
      },
      captchaKey: process.env.VUE_APP_CAPTCHA_KEY,
      isLocalhost: window.location.origin.includes("localhost") ? true : false,
    };
  },
  methods: {
    imgClick() {
      return this.$router.push("/");
    },
    btnLoginClick() {
      if (!this.isLocalhost) {
        const captchaResponse = grecaptcha.getResponse();
        if (!captchaResponse) {
          this.$vs.notify({
            text: "Please complete the captcha",
            color: "danger",
            position: "top-right",
          });
          return;
        }
      }
      this.$vs.loading();
      api
        .post(API.LOGIN, this.$data.login)
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            if (r.data.account.email) {
              const token = r.data.genToken;
              r.data.account.token = token;
              this.$ls.set("user", JSON.stringify(r.data.account));
            }
            if (r.data.genToken != undefined) {
              const token = r.data.genToken;
              r.data.account.token = token;
              this.$ls.set("admin", JSON.stringify(r.data.account));
            }
            if (r.data.account.email) {
              this.$vs.notify({
                text: "Welcome " + r.data.account.name,
                color: "success",
                position: "top-right",
              });
              this.$router.push("/");
            } else {
              this.$vs.notify({
                text: "User Not Found",
                color: "danger",
                position: "top-right",
              });
            }
          }
        })
        .catch((_) => {
          this.$vs.notify({
            text: "Invalid Credentials",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    if (this.$route.query.session_expired) {
      this.$vs.notify({
        text: "Your session has expired. Please log in again.",
        color: "warning",
        position: "top-right",
      });
    }
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
};
</script>
<style scoped>
.mt60 {
  margin-top: 60px;
  padding: 30px;
}
.flink {
  text-align: right;
  padding-top: 12px;
}
</style>
